import Ajax from '../../../fc-core/src/ajax';
import { triggerEvent } from '../../../fc-core/src/event-api';
var SOURCE_NAME = 'XmlHttpRequest';
var UNDEF;

function onDataLoadComplete(a, b) {
  a.sender.jsVars.stallLoad = !1, a.sender.setChartData(b.dataSource, b.dataFormat, b.config, b.successcallback, b.silent);
}

function onDataLoadCancel(a, b) {
  triggerEvent('dataLoadCancelled', a.sender, b), b.xmlHttpRequestObject.abort();
}

function xmlhttpSuccess(a, b, c, d) {
  var e = c.obj,
      f = c.args;
  f.dataSource = a, f.xmlHttpRequestObject = b, f.source = SOURCE_NAME, f.url = d, triggerEvent('dataLoadRequestCompleted', e, f, UNDEF, onDataLoadComplete, onDataLoadCancel);
}

function xmlhttpFailure(a, b, c) {
  var d = c.obj,
      e = c.args;
  e.error = a, e.httpStatus = b.xhr && b.xhr.status ? b.xhr.status : -1, e.xmlHttpRequestObject = b, d._addChartDependency('data', {
    resolve: function resolve() {
      return {
        state: 1,
        msg: d.options.dataLoadErrorMessage,
        msgStyle: {
          image: {
            imageHAlign: d.args.dataLoadErrorMessageImageHAlign || d.options.baseChartMessageImageHAlign,
            imageVAlign: d.args.dataLoadErrorMessageImageVAlign || d.options.baseChartMessageImageVAlign,
            imageAlpha: d.args.dataLoadErrorMessageImageAlpha || d.options.baseChartMessageImageAlpha,
            imageScale: d.args.dataLoadErrorMessageImageScale || d.options.baseChartMessageImageScale
          },
          message: {
            color: d.args.dataLoadErrorMessageColor || d.options.baseChartMessageColor,
            fontFamily: d.args.dataLoadErrorMessageFont || d.options.baseChartMessageFont,
            fontSize: d.args.dataLoadErrorMessageFontSize || d.options.baseChartMessageFontSize
          }
        }
      };
    }
  }), d._setState(), triggerEvent('dataLoadError', d, e);
}

function onDataLoadRequest(a, b) {
  var c = a.sender,
      d = c.__state,
      e = b.url;
  c.options.dataSource = b.url, d.dhmXhrObj || (d.dhmXhrObj = new Ajax(xmlhttpSuccess, xmlhttpFailure)), d.dhmXhrObj.get('function' == typeof window.decodeURIComponent ? window.decodeURIComponent(e) : window.unescape(e), {
    obj: c,
    args: b
  });
}

function onDataLoadRequestCancel(a, b) {
  var c = a.sender,
      d = c.__state;
  triggerEvent('dataLoadRequestCancelled', c, b), d && d.dhmXhrObj && d.dhmXhrObj.abort();
}

export { SOURCE_NAME as sourceName, onDataLoadRequest, onDataLoadRequestCancel };